import {
  MutationFunction,
  MutationKey,
  useMutation,
  UseMutationOptions,
} from '@tanstack/react-query';
import { ApiErrorResponse } from '../ApiClient';

export type UseApiMutationOptions<ResponseData, RequestData> = Omit<
  UseMutationOptions<ResponseData, ApiErrorResponse, RequestData>,
  'mutationKey' | 'mutationFn'
>;

export const createApiMutationHook =
  <RequestData extends Record<string, any> | void, ResponseData>(
    mutationKey: MutationKey,
    mutationFn: MutationFunction<ResponseData, RequestData>,
    baseOptions?: Partial<UseApiMutationOptions<ResponseData, RequestData>>,
  ) =>
  (options?: UseApiMutationOptions<ResponseData, RequestData>) =>
    useMutation({
      ...baseOptions,
      ...options,
      mutationKey,
      mutationFn,
    });
